import { byMedia } from '../helpers/media';
var BOX_SIZING = {
  border: 'border-box',
  content: 'content-box'
};
export var boxSizing = byMedia(function (value) {
  return "box-sizing: " + (BOX_SIZING[value] || value) + ";";
});